import React, { useState } from 'react';
import { Form, Button, Spinner, Row, Col, InputGroup } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { singIn } from '../../redux/auth/actions';
import logo from '../../images/logo2.png';

const SingIn = props => {
  //states
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  //redux
  const dispatch = useDispatch();
  const loadingAuth = useSelector(store => store.auth.loadingAuth);

  const onSingIn = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    const data = {
      username: username,
      password: password
    };
    dispatch(singIn(data, props));
  }

  return (
    <div className="singin-wrapper">
      <div className="inner-singin">
        <Row>
          <Col lg={{ span: 8, offset:2 }}
               md={{ span: 10, offset: 1 }}
               sm={{ span: 10, offset: 1 }}
               xs={{ span: 10, offset: 1 }}>
            <h2 className="mb-5">Iniciar Sesión</h2>
            <Form noValidate validated={validated} className="mb-5" onSubmit={onSingIn}>
              <Form.Group>
                <Form.Label className="ml-2">Usuario</Form.Label>
                <Form.Control
                  required 
                  onChange={e => setUsername(e.target.value)}
                  className="rounded-pill" 
                  type="text" 
                  placeholder="Número de empleado" />
                  <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                {/* <Form.Label className="ml-2">Contraseña</Form.Label>
                <Form.Control
                  required
                  onChange={e => setPassword(e.target.value)} 
                  className="rounded-pill" 
                  type="password" 
                  placeholder="Contraseña" />
                   <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback> */}
                <InputGroup className="mb-3">
                  <Form.Control
                    required
                    onChange={e => setPassword(e.target.value)}
                    type={showPassword ? 'text' : 'password'} name="oldPassword"
                    placeholder="Password"
                    style={{ borderTopLeftRadius: '50rem', borderBottomLeftRadius: '50rem' }}
                    aria-describedby="basic-addon1"
                  />
                  <InputGroup.Append>
                    <Button onClick={() => setShowPassword(!showPassword)} variant="outline-secondary" style={{ borderTopRightRadius: '50rem', borderBottomRightRadius: '50rem' }}>
                      {showPassword
                        ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye text-muted" />}
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </Form.Group>
              <div className="mt-4">
                <Button
                  disabled={loadingAuth} 
                  className="rounded-pill" 
                  variant="primary" 
                  type="submit">
                    {
                      loadingAuth && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true" />
                      )
                    }
                    Iniciar Sesión</Button>
              </div>
            </Form>
            <p>¿Olvide mi contraseña? <Link to="/recuperarcontrasenia">Recuperar contraseña</Link></p>
          </Col>
        </Row>
        <div className="singin-mark text-center copyri">
          <small className="text-muted mr-2">© Grupo Farinter 2021 todos los derechos reservados</small>
          <small className="text-muted"><Link to="!#">Términos y condiciones</Link></small>
        </div>
      </div>
      <div className="singin-desc">
        <Row>
          <Col lg={{ span: 9, offset:1 }}>
            {/*<img src={logo} className="logo" alt="Logo" />*/}
            <img src={logo} style={{width: '290px', height: '250px', marginLeft: '-2.3rem', marginTop: '-2rem'}} alt="Logo" />
            <div style={{ marginTop: '-3rem' }}>
              <h1 className="mb-4 font-weight-bold">Sistema de Gestión de Recursos Humanos</h1>
            </div>
            {/* <p className="mb-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam distinctio labore, similique earum sint odit minima dicta asperiores. Obcaecati, totam?</p>
            <Link to="/inicio" className="btn btn-warning rounded-pill">Solicitar registro</Link> */}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default withRouter(SingIn)
